import { gql } from '@apollo/client';

/**
 * The client-app quest band's slice of the quest schema — the same documents the
 * town-square band uses (kept small on purpose; the full set lives in town-square's
 * quest-queries.ts).
 */

export interface ScoredQuestStep {
  code: string;
  weight: number;
  earned: number;
  complete: boolean;
  blocked: boolean;
  label: string;
  evidence: string;
  href: string;
  opens: string;
  minutes: number | null;
  completedBy: string | null;
  completion: 'measured' | 'click';
}

export interface ScoredQuest {
  slug: string;
  name: string;
  heading: string;
  questType: string;
  emoji: string | null;
  color: string | null;
  pointsReward: number;
  score: number;
  rung: string;
  complete: boolean;
  /** How many days the quest runs over. 1 when it carries no day breaks. */
  totalDays: number;
  /** once | daily | weekly | monthly */
  cadence: string;
  /** When the current period ends, for a recurring quest; null for a one-off. */
  periodEndsAt: string | null;
  /** Member zone that periodEndsAt is midnight in. Null for a one-off. */
  periodTimeZone: string | null;
  /** The day she is on — the lowest unfinished one, capped at what has opened. */
  currentDay: number;
  /** Today's steps are done and another day is still to come. */
  isDayComplete: boolean;
  /** ISO time the next day opens, in her own zone. Null when nothing is waiting. */
  dayUnlocksAt: string | null;
  nextStepCode: string | null;
  /** Whether it may take the band — false when its admin unticked "pin to top". */
  pinned: boolean;
  /** Only the steps OPEN to her — a locked day is never sent. */
  steps: ScoredQuestStep[];
}

export const MY_QUESTS = gql`
  query ClientMyQuests {
    myQuests {
      slug
      name
      heading
      questType
      emoji
      color
      pointsReward
      score
      rung
      complete
      totalDays
      cadence
      periodEndsAt
      periodTimeZone
      currentDay
      isDayComplete
      dayUnlocksAt
      nextStepCode
      pinned
      steps {
        code
        weight
        earned
        complete
        blocked
        label
        evidence
        href
        opens
        minutes
        completedBy
        completion
      }
    }
  }
`;

export const COMPLETE_QUEST_STEP = gql`
  mutation ClientCompleteQuestStep($stepCode: String!, $source: String!) {
    completeQuestStep(stepCode: $stepCode, source: $source) {
      ok
      stepPointsAwarded
    }
  }
`;

export const UNCOMPLETE_QUEST_STEP = gql`
  mutation ClientUncompleteQuestStep($stepCode: String!) {
    uncompleteQuestStep(stepCode: $stepCode)
  }
`;

export const RETIRE_QUEST = gql`
  mutation ClientRetireQuest($slug: String!) {
    retireQuest(slug: $slug)
  }
`;
